import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useViewerStore, actions } from '@store/viewerModule/base';
import { DatePicker } from 'antd';
import { selector as commonSelector } from '@store/common';
import { advancedViewerModuleFeatureSelector, show90DaysViewerDataSelector } from '@store/common/selectors';
import { getLocalTime } from './utils';
import { ArrowRightOutlined } from '@ant-design/icons';

const { RangePicker } = DatePicker;

function CustomDate({ closeCustom, containerRef }) {
  const [{ interval }, dispatch] = useViewerStore();
  const common = useSelector(commonSelector);
  const { tzOffset } = common;
  const isAdvancedVMEnabled = useSelector(advancedViewerModuleFeatureSelector);
  const showNinetyDays = useSelector(show90DaysViewerDataSelector);
  let daysToSubract = 7;
  if (showNinetyDays) {
    daysToSubract = 90;
  } else if (isAdvancedVMEnabled) {
    daysToSubract = 30;
  }
  const offSetDate = moment().subtract(daysToSubract, 'days').startOf('day');
  const allowedDateMoment = moment(getLocalTime(offSetDate, tzOffset));
  const dateFormat = 'YYYY-MM-DD';

  const onCustomSelection = (interval) => {
    // start_date=2021-10-06&end_date=2021-10-12
    const currentInterval = {
      startDate: moment(interval[0]).startOf('day').format(),
      endDate: moment(interval[1]).endOf('day').format(),
      isCustom: true,
      isLive: false,
      days: 1,
    };
    dispatch(actions.setInterval({ interval: currentInterval }));
    dispatch(actions.setAdvanced({ showAdvanceDetails: false }));
    dispatch(actions.setRowData({ rowData: {} }));
    closeCustom();
  };

  const disableDates = (calendarDate) => {
    const calendarDateMoment = moment(calendarDate);
    return moment().isBefore(calendarDateMoment) || calendarDateMoment.isBefore(allowedDateMoment) || calendarDateMoment.isBefore(moment().subtract(13, 'months').startOf('day'));
  };

  // calc date for display
  const selectedValue: any = interval.isCustom ?
    [moment(interval.startDate), moment(interval.endDate)]
    : [moment(), moment().subtract('days', interval.days)];

    return (
      <div style={{width: '240px'}}>
        <RangePicker
          format={dateFormat}
          value={selectedValue}
          // defaultPickerValue={[moment().add(-1, 'month'), moment()]}
          separator={<ArrowRightOutlined/>}
          disabledDate={disableDates}
          onChange={onCustomSelection}
          getPopupContainer={() => containerRef.current} /* tslint:disable-line */
        />
      </div>
    );

}

export default CustomDate;
